import { render, staticRenderFns } from "./CustomConfirmModalAlert.vue?vue&type=template&id=0bd7ec9a"
import script from "./CustomConfirmModalAlert.vue?vue&type=script&lang=js"
export * from "./CustomConfirmModalAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports